import { YandexMetrikaHitOptions, YandexMetrikaMethod } from "./types";

declare const ym: (
  id: number,
  method: YandexMetrikaMethod,
  ...params: unknown[]
) => void;

const isProd = !!(process.env.NODE_ENV === "production");
const metrikaId = process.env.NEXT_PUBLIC_YANDEX_METRIKA_ID
  ? parseInt(process.env.NEXT_PUBLIC_YANDEX_METRIKA_ID)
  : null;

// fire metrika events only for prod with metrika id
// for dev, log events to console

export const useMetrika = () => {
  const hit = (url?: string, options?: YandexMetrikaHitOptions) => {
    if (isProd && metrikaId) {
      ym(metrikaId, "hit", url, options);
    } else if (!isProd) {
      console.log(`%c[YandexMetrika](hit)`, `color: orange`, url);
    }
  };

  const reachGoal = (
    target: string,
    params?: unknown,
    callback?: () => void,
    ctx?: unknown
  ) => {
    if (isProd && metrikaId) {
      ym(metrikaId, "reachGoal", target, params, callback, ctx);
    } else if (!isProd) {
      console.log(`%c[YandexMetrika](reachGoal)`, `color: orange`, target);
    }
  };

  return { hit, reachGoal };
};
